var map = {
	"./file-lg-blue.svg": 4853,
	"./file-lg-green.svg": 2573,
	"./file-lg-red.svg": 3214,
	"./file-lg-yellow.svg": 9111,
	"./file-sm-blue.svg": 5549,
	"./file-sm-green.svg": 3881,
	"./file-sm-red.svg": 617,
	"./file-sm-yellow.svg": 2198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 661;